import React from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import FactsContext from '@Components/Results/substances/contexts/facts.context';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import SubstancePropertyComponent from '@Components/Results/substances/substance-property.component';

function findHitDataFact(facts) {
  return find(facts, (fact) => fact.hitData);
}

export default class SubstanceHitData extends React.PureComponent {
  render() {
    const { metadata, substance, database } = this.props;
    const { index: substanceIndex, details } = substance;

    return (
      <FactsContext.Consumer>
        {({ facts, toggle }) => {
          const fact = findHitDataFact(facts);

          return (
            fact && (
              <div
                id={`substances-hitdata-${substanceIndex}`}
                className="substance-results-information substances-hit-details"
                aria-expanded>
                <div className="substances-hit-details__container">
                  <ul className="rx-accordion medium">
                    <SubstancePropertyComponent
                      metadata={metadata}
                      fact={findHitDataFact(facts)}
                      toggle={toggle}
                      details={details}
                      database={database}
                      substanceIndex={substanceIndex}
                      substance={substance}
                    />
                  </ul>
                </div>
              </div>
            )
          );
        }}
      </FactsContext.Consumer>
    );
  }
}

SubstanceHitData.propTypes = {
  metadata: MetadataPropTypesShape,
  substance: PropTypes.object.isRequired,
  database: PropTypes.object.isRequired,
};
